import { useEffect, useState } from 'react';
import type { AppDispatch, RootState } from './types';
import { appStore } from './Store';

export const useAppDispatch = (): AppDispatch => appStore.dispatch as AppDispatch;

export const useAppSelector = <TSelected>(selector: (state: RootState) => TSelected): TSelected => {
    const [selected, setSelected] = useState<TSelected>(() => selector(appStore.getState() as RootState));

    useEffect(() => {
        const unsubscribe = appStore.subscribe(() => {
            setSelected(selector(appStore.getState() as RootState));
        });

        return unsubscribe;
    }, [selector]);

    return selected;
};
